import Container from '@material-ui/core/Container';

import WelcomeBox from "./WelcomeBox";
import PersonalData from "./PersonalData";
import B2BTable from './B2BTable';
import SuccessfullModal from './B2BTable/SuccessfullModal';


const B2BPortals = ({
    clientData,
    selectedCountry,
    handleClickAddB2B,
    isLoadingSubmit,
    isVisibleSuccessfullModal,
    portalInfoData,
    handleChangePortal,
    handleChangePortalLink,
    handleClickOKModal,
    handleClickCancelModal,
    isErrorB2BAddRequest,
    removeLastB2BRowTable,
    isClickedAddB2BManual,
    showModal,
    setShowModal,
    handleChangeUserTypeWalmart,
    isGS1 = false,
}) => {

    return (
        <>
        <WelcomeBox />
        <Container>
            <div className="row">
                <div className="col-12">
                    <Container className="container-form-4 general-container">
                        <div className="row p-1">
                            <div className="col-12">
                                {showModal !== false  ? (
                                    <>
                                        <PersonalData
                                            clientPersonalData={clientData.personal_data}
                                            selectedCountry={selectedCountry}
                                        />
                                        <br /><br />
                                    </>
                                ) : null}
                                <B2BTable
                                    clientData={clientData}
                                    handleClickAddB2B={handleClickAddB2B}
                                    isLoadingSubmit={isLoadingSubmit}
                                    portalInfoData={portalInfoData}
                                    handleChangePortal={handleChangePortal}
                                    handleChangePortalLink={handleChangePortalLink}
                                    isErrorB2BAddRequest={isErrorB2BAddRequest}
                                    removeLastB2BRowTable={removeLastB2BRowTable}
                                    isClickedAddB2BManual={isClickedAddB2BManual}
                                    showModal={showModal}
                                    setShowModal={setShowModal}
                                    handleChangeUserTypeWalmart={handleChangeUserTypeWalmart}
                                    isGS1={isGS1}
                                />
                            </div>
                        </div>
                    </Container>
                </div>
            </div>
        </Container>

        <SuccessfullModal
            showModal={isVisibleSuccessfullModal}
            handleClickOKModal={handleClickOKModal}
            handleClickCancelModal={handleClickCancelModal}
            clientData={clientData.personal_data}
            selectedCountry={selectedCountry}
            ShowSpecialModal={showModal}
            setShowModal={setShowModal}
        />
        </>
    );
};

export default B2BPortals;
